import { Box } from "../../box";
import { forwardRef } from "react";
import { mergeProps } from "../../shared";
import { useInputGroupAddonProps } from "../../input-group";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "div";
export function InnerTextAddon(props) {
  const [inputGroupAddonProps] = useInputGroupAddonProps();
  const {
    as = DefaultElement,
    children,
    forwardedRef,
    ...rest
  } = mergeProps(props, inputGroupAddonProps);
  return /*#__PURE__*/_jsx(Box, { ...mergeProps(rest, {
      as,
      className: "o-ui-input-group-text-addon",
      ref: forwardedRef
    }),
    children: children
  });
}
InnerTextAddon.defaultElement = DefaultElement;
export const TextAddon = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerTextAddon, { ...props,
  forwardedRef: ref
}));